// extracted by mini-css-extract-plugin
module.exports = {"clickable":"clickable--c1sM3PuoM-"};